export const getFilters = (state, id) => {
    const idState = state.filterHeader[id];
    return idState ? idState.filters : [];
};

export const getDefaultFilters = (state, id) => {
    const idState = state.filterHeader[id];
    return idState ? idState.defaultFilters : [];
};

export const getCurrentlyOpenFilter = (state, id) => {
    const idState = state.filterHeader[id];
    return idState ? idState.currentlyOpenFilter : null;
};

export const getCurrentlyOpenDefaultFilter = (state, id) => {
    const idState = state.filterHeader[id];
    return idState ? idState.currentlyOpenDefaultFilter : null;
};
